"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _audioPreview = _interopRequireDefault(require("./audioPreview"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Example for this renderer:
 *   "renderAs": {
 *       "type": "Audio",
 *       "class": "html",
 *       "settings": {
 *           "audioUrlPath": "fields.name_audio"
 *       }
 *   }
 */
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var audioUrl = row[settings.audioUrlPath];
    if (!audioUrl) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_audioPreview["default"], {
      audioUrl: audioUrl,
      row: row
    });
  };
};